/* import __COLOCATED_TEMPLATE__ from './account-relationship.hbs'; */
var _dec, _dec2, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { select } from '@banking/ui/services/investments-workflow';
import { createInvestmentAccountRequestAction, cashAppIdentifier, setOnboardingScreenAction } from '@banking/ui/workflows/investments';
import { INVEST_SET_ACCOUNT_RELATIONSHIP } from '@banking/ui/utils/invest-cdp-events';
import { Owner, OwnerType } from '@square/dashboard-protos/models/squareup/banking/common';
import { InvestmentAccountMetadata } from '@square/dashboard-protos/models/squareup/invest/model';
import { tracked } from '@glimmer/tracking';
let AccountRelationship = (_dec = select(cashAppIdentifier), _dec2 = select(state => state.isLoading), _class = class AccountRelationship extends Component {
  get options() {
    return [{
      label: this.intl.t('banking.investments.automation.relationship.owner'),
      value: 'OWNER'
    }, {
      label: this.intl.t('banking.investments.automation.relationship.partner'),
      value: 'PARTNER_SPOUSE'
    }, {
      label: this.intl.t('banking.investments.automation.relationship.llcMember'),
      value: 'LLC_MEMBER'
    }, {
      label: this.intl.t('banking.investments.automation.relationship.principalOfficer'),
      value: 'PRINCIPAL_OFFICER'
    }, {
      label: this.intl.t('banking.investments.automation.relationship.other'),
      value: 'OTHER'
    }];
  }
  constructor(owner, args) {
    super(owner, args);
    _initializerDefineProperty(this, "capitalEngineContext", _descriptor, this);
    _initializerDefineProperty(this, "investmentsWorkflow", _descriptor2, this);
    _initializerDefineProperty(this, "dataApi", _descriptor3, this);
    _initializerDefineProperty(this, "sentry", _descriptor4, this);
    _initializerDefineProperty(this, "merchantMainUnit", _descriptor5, this);
    _initializerDefineProperty(this, "userInfo", _descriptor6, this);
    _initializerDefineProperty(this, "intl", _descriptor7, this);
    _initializerDefineProperty(this, "cashAppIdentifier", _descriptor8, this);
    _initializerDefineProperty(this, "isLoading", _descriptor9, this);
    _initializerDefineProperty(this, "selectedRelationship", _descriptor10, this);
    _initializerDefineProperty(this, "invalidSelection", _descriptor11, this);
    _initializerDefineProperty(this, "merchantName", _descriptor12, this);
    this.init();
  }
  async init() {
    this.merchantName = await this.getMerchantName();
  }
  async getMerchantName() {
    const mainUnit = await this.merchantMainUnit.findMainUnit();
    const merchantName = mainUnit?.merchantProfile?.name || this.userInfo.name || this.intl.t('banking.investments.automation.create.linking.valueprop.fallbackName');
    return merchantName;
  }
  updateRelationship(event) {
    const value = InvestmentAccountMetadata.AccountRelationship[event.detail.value];
    this.selectedRelationship = value;
    this.invalidSelection = !this.selectedRelationship;
  }
  goNext() {
    if (!this.selectedRelationship) {
      this.invalidSelection = true;
      return;
    }
    this.dataApi.track(INVEST_SET_ACCOUNT_RELATIONSHIP, {
      accountRelationship: this.selectedRelationship,
      token: this.capitalEngineContext.sessionContext.merchantToken
    });
    if (this.selectedRelationship === InvestmentAccountMetadata.AccountRelationship.OTHER) {
      this.investmentsWorkflow.emit(setOnboardingScreenAction('accountRelationshipUnsupported', true));
      return;
    }
    const owner = Owner.create({
      type: OwnerType.MERCHANT,
      id: this.capitalEngineContext.sessionContext.merchantToken
    });
    try {
      this.investmentsWorkflow.emit(createInvestmentAccountRequestAction(owner, this.selectedRelationship));
    } catch (error) {
      this.sentry.captureException(error);
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "capitalEngineContext", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "investmentsWorkflow", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "dataApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "sentry", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "merchantMainUnit", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "userInfo", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "cashAppIdentifier", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "isLoading", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "selectedRelationship", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "invalidSelection", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "merchantName", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _applyDecoratedDescriptor(_class.prototype, "updateRelationship", [action], Object.getOwnPropertyDescriptor(_class.prototype, "updateRelationship"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "goNext", [action], Object.getOwnPropertyDescriptor(_class.prototype, "goNext"), _class.prototype), _class);
export { AccountRelationship as default };